var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgUserOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08232 8.03653C9.32569 8.03653 11.1443 6.23749 11.1443 4.01826C11.1443 1.79904 9.32569 0 7.08232 0C4.83895 0 3.02034 1.79904 3.02034 4.01826C3.02034 6.23749 4.83895 8.03653 7.08232 8.03653ZM7.08232 6.22831C8.31617 6.22831 9.31641 5.23884 9.31641 4.01826C9.31641 2.79769 8.31617 1.80822 7.08232 1.80822C5.84847 1.80822 4.84823 2.79769 4.84823 4.01826C4.84823 5.23884 5.84847 6.22831 7.08232 6.22831Z",
    fill: "var(--secondary-5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08242 9.14156C3.49303 9.14156 0.583252 12.02 0.583252 15.5708V22H13.5816V15.5708C13.5816 12.02 10.6718 9.14156 7.08242 9.14156ZM2.41114 15.5708C2.41114 13.0187 4.50254 10.9498 7.08242 10.9498C9.66229 10.9498 11.7537 13.0187 11.7537 15.5708V20.1918H2.41114V15.5708Z",
    fill: "var(--secondary-5)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutlined);
export default __webpack_public_path__ + "static/media/userOutlined.6735e1317807b35137e55a3ad774619b.svg";
export { ForwardRef as ReactComponent };